export const precallMemoryConstants = {
    REMEMBER_DEVICE_CHECK: "REMEMBER_DEVICE_CHECK",
    FORGET_DEVICE_CHECK: "FORGET_DEVICE_CHECK",
}
